import { Component, Input } from '@angular/core';

import { BadgeVariantEnum } from './enums/variant.enum';
import { VtmnPlayIconTypeEnum } from '../vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
})
export class BadgeComponent {
  @Input() public icon?: VtmnPlayIconTypeEnum;
  @Input() public iconClass?: string;
  @Input() public variant = BadgeVariantEnum.YELLOW;

  public get className(): string {
    return `badge--${this.variant}`;
  }
}
